import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const Container = styled.div`
    width:100%;
    margin-bottom:30px;
    @media screen and (max-width:768px) {
       margin:10px 0;
    }
`
const BackDrop = styled.div`
    position:relative;
    width:99%;
    height:400px;
    background:url(${props => props.url});
    background-repeat:no-repeat;
    background-size:cover;
    background-position: center center;
    margin:auto;
    border-radius:5px;
    @media screen and (max-width:768px) {
        height:170px;
    }
`
const Data = styled.div`
      position:absolute;
    width:100%;
    height:100%;
    top:0%;
    left:0%;
    z-index:99;
    div{
        cursor:pointer;
        color:white;
        font-weight:500;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        padding:7px 100px;
        border-radius:10px;
        font-size:50px;
        background:rgba(0,0,0,0.5);
        animation: headline 3s ease-in-out;
        @keyframes headline {
           0%{
                opacity:0;
                padding:7px 0;
            }
            85%{
                padding:7px 100px
            }
        }
    }
    @media screen and (max-width:1450px) {
        div{
            padding:7px 5%;
            font-size:32px;
            min-width:65%;
            max-width:80%;
            text-align:center;
            margin:auto;
            @keyframes headline {
           0%{
                opacity:0;
                padding:7px 0;
            }
            85%{
                padding:7px 5%
            }
        }
        }
    }
    @media screen and (max-width:768px) {
        div{
            width:100%;
            font-size:20px;
            padding:5px;
            border-radius:unset;
            text-align:center;
            animation:unset;
            min-width:unset;
            max-width:unset;
        }
    }
   
`

const TvComponent = () => {
    return (
        <Container>
            <Link to='/show/2304/'>
                <BackDrop url={`https://image.tmdb.org/t/p/original/wIe1HL7oMNwyltsqqx2sCPwNl4w.jpg`} >
                    <Data>
                        <div>Do you know Thomas?</div>
                    </Data>
                </BackDrop>
            </Link>
        </Container>
    )
}

export default TvComponent
